<script>
    import { fade } from 'svelte/transition';

    export let offset = { x: 5, y: 5 };
    export const handles = { start, move, stop };

    let coords = [0, 0];
    let item = null;
    let is_poi_;

    // --- handles

    function start(e, d, is_poi = false) {
        move(e);
        item = d;
        console.log(d);
        is_poi_ = is_poi;
    }

    function move(e) {
        coords = [e.pageX + offset.x, e.pageY + offset.y];
    }

    function stop() {
        item = null;
        coords = [0, 0];
    }

    // --- Helpers

    function displayDuration(duration) {
        const hours = Math.floor(duration / 3600);
        const minutes = Math.floor((duration % 3600) / 60);
        const seconds = duration % 60;
        return `${hours}h ${minutes}m ${seconds}s`;
    }
</script>

{#if item}
    <div
        transition:fade={{ duration: 50 }}
        class="tooltip col"
        style="left:{coords[0]}px;top:{coords[1]}px"
    >
        {#if !is_poi_}
            <span><b>Car</b>: {item.car}</span>
            <span
                ><b>Start</b>: {item.start.display_time} January {item.start
                    .day}
            </span>
            <span
                ><b>Stop</b>: {item.stop.display_time} January {item.stop.day}
            </span>
            <span><b>Duration</b>: {displayDuration(item.duration)}</span>
            <span><b>Distance</b>: {item.distance.toFixed(0)}m</span>
            <span><b>Speed</b>: {item.speed.toFixed(2)}km/h</span>
        {:else}
            <span>{item.lat} - {item.long}</span>
        {/if}
    </div>
{/if}

<style>
    .tooltip {
        border: 1px solid #ddd;
        box-shadow: 1px 1px 1px #ddd;
        background: white;
        border-radius: 4px;
        position: absolute;
        font-size: 12px;
        z-index: 1;
        padding: 5px;
    }
</style>
